import { categories } from "../../../mocks/chiagua";

const colorMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function Columns() {
  return (
    <section id="column" className="bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="text-secondary-700 text-sm font-semibold tracking-widest">COLUMNS</span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mt-2">话题分类 · 挑你爱看的瓜</h2>
            <p className="text-foreground-600 text-sm md:text-base mt-3">
              从娱乐到行业、从舞台到商业，六大栏目把最热话题分门别类摆上桌。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mt-8 md:mt-10">
          {categories.map((c) => (
            <a
              key={c.id}
              href="#live"
              className="group bg-background-100/70 border border-background-200/70 rounded-2xl p-5 flex items-start gap-4 hover:border-secondary-400 transition-colors cursor-pointer"
            >
              <span
                className={`w-12 h-12 shrink-0 rounded-xl flex items-center justify-center text-2xl ${colorMap[c.color]}`}
              >
                <i className={c.icon}></i>
              </span>
              <span className="flex-1 min-w-0">
                <span className="flex items-center justify-between gap-2">
                  <span className="text-foreground-950 font-semibold text-base group-hover:text-secondary-700 transition-colors">
                    {c.name}
                  </span>
                  <i className="ri-arrow-right-line text-foreground-400 group-hover:text-secondary-600 transition-colors"></i>
                </span>
                <span className="block text-foreground-600 text-sm mt-1.5 leading-relaxed">{c.desc}</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}